<template>
    <modal-side-generic
    :title="t('userArea.profile.qrCodeTitle')"
    @hideMe="emit('hideMe')">
        <div class="details-wrapper" :class="{ mobile: isMobile }">
            <div class="details-title">{{t('userArea.profile.qrCodeMessage')}}</div>
            <div class="details-message">{{t('userArea.profile.qrCodeSubMessage')}}</div>
            <div class="qr-code-image" :style="{'backgroundImage': imageUrl }"></div>
        </div>
    </modal-side-generic>
</template>

<script setup>
import ModalSideGeneric from '@/components/generic/modals/side/Generic'

/* Vue */
import { computed } from 'vue'
import { requestQRCodeImageUrl } from '@/network/api/customers/customers.api.js'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe'])

/** Props received
    @isMobile { Boolean }
*/
const props = defineProps({
    isMobile: Boolean
})

const imageUrl = computed(() => {
    return `url(${requestQRCodeImageUrl()})`
})

</script>

<style lang="scss" scoped>
.details-wrapper {
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    text-align: left;

    .details-title {
        margin-bottom: 12px;

        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        word-wrap: break-word;
    }

    .details-message {
        margin-bottom: 48px;

        color: var(--secondary-dark-3);
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        word-wrap: break-word;
    }

    .qr-code-image {
        width: 272px;
        height: 272px;

        align-self: center;

        background-position: center;
        background-repeat: no-repeat;
        background-size: auto;
    }

    &.mobile {
        padding: 0 16px;
    }
}
</style>
